export default "__VITE_ASSET__qz7_FAT7__"